export interface MtnStatusLike {
  statusCode?: string | number | null;
  isActive?: boolean;
  subscriptionDetails?: { subscriptionState?: string | null } | null;
}

export function isUsableMtnStatus(
  status: MtnStatusLike | null | undefined,
): boolean {
  return (
    (status?.statusCode === '0' || status?.statusCode === 0) &&
    Boolean(status.subscriptionDetails?.subscriptionState?.trim())
  );
}

export function resolveMtnStatus<
  T extends MtnStatusLike,
  U extends MtnStatusLike,
>(liveStatus: T | null | undefined, localStatus: U): T | U {
  return liveStatus && isUsableMtnStatus(liveStatus) ? liveStatus : localStatus;
}

export function getMtnStatusLabel(
  status: MtnStatusLike | null | undefined,
): string {
  if (!status) {
    return 'Unknown';
  }

  if (status.statusCode === 'LOCAL') return 'Unknown / unverified';
  const hasKnownStatus = isUsableMtnStatus(status);

  if (!hasKnownStatus) {
    return 'Unknown';
  }

  return status.subscriptionDetails!.subscriptionState!.trim();
}
